export * from "./PrizeDetails";
